import { ActionKeys } from './constants';

export type DialogType = 'default' | 'error' | 'success';

interface ShowDialogProps {
  closeButtonText: string;
  confirmButtonText?: string;
  messages: string[];
  title?: string;
}

export const showDialog = (props: ShowDialogProps, dialogType: DialogType) =>
  <const>{
    payload: {
      dialogType,
      props,
    },
    type: ActionKeys.DIALOG_SHOW,
  };

export const hideDialog = () =>
  <const>{
    type: ActionKeys.DIALOG_HIDE,
  };

export type DialogActions = ReturnType<typeof hideDialog> | ReturnType<typeof showDialog>;
